
import { Component, Prop, Vue, Watch, Emit } from "vue-property-decorator";
@Component
export default class MenuItems extends Vue {
  
}
